import { DateTime } from "luxon";
const currencyFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
const compactCurrencyFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 2, minimumFractionDigits: 2});
const compactCurrencyFormatterRounded = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 0, minimumFractionDigits: 0});

export const formatCurrency = (v, compact = false, rounded = false) => {
    if (v === 0) return '$0';
    return v ? (compact ? rounded ? compactCurrencyFormatterRounded.format(v): compactCurrencyFormatter.format(v) : currencyFormatter.format(v)) : null;
};

export const formatPercent = (v, places, showPlusSign = false) => {
    return v ? `${showPlusSign && v > 0 ? '+' : ''}${(parseFloat(v) * 100).toFixed(places)}%` : null;
};

export const formatNumber = (v) => {
    return v ? (+v).toLocaleString() : null;
};

export const formatDate = (v) => {
    return v ? DateTime.fromISO(v).toLocaleString() : null;
};

export const normalizeHierarchyNames = (names) => {
    if (!names) {
        return [];
    }
    if (typeof names === 'string') {
        if (names === '{}') {
            return [];
        }
        if (names.startsWith('{') && names.endsWith('}')) {
            const inner = names.slice(1, -1);
            if (!inner) {
                return [];
            }
            return inner.match(/("([^"]|"")*"|[^,]+)/g).map((part) => {
                const trimmed = part.trim();
                if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
                    return trimmed.slice(1, -1).replace(/""/g, '"');
                }
                return trimmed;
            });
        }
        return names.split(',').map((part) => part.trim()).filter(Boolean);
    }
    if (Array.isArray(names)) {
        return names.flat(Infinity).filter((part) => typeof part === 'string' && part.length > 0);
    }
    return [];
};

export const formatHierarchyNames = (names, separator = ' › ') => {
    const normalized = normalizeHierarchyNames(names);
    if (normalized.length === 0) {
        return '—';
    }
    return normalized.join(separator);
};

export const getAccountHierarchyNames = (row) => (
    row?.accountHierarchyNames
    ?? row?.account_hierarchy_names
    ?? row?.hierarchyNames
    ?? row?.hierarchy_names
);

export const getProductHierarchyNames = (row) => (
    row?.productHierarchyNames
    ?? row?.product_hierarchy_names
);
